import PropTypes from 'prop-types';
import React from 'react';

import OrderFare from '../../records/order/Fare';
import { translate as t } from '../../lib/I18n';
import { getFoldedTickets } from '../../helpers/Fares';

import TicketDetails from '../fares/details/TicketDetails';
import FareRefundsInfo from '../fares/FareRefundsInfo';


class FarePassengers extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        orderFare: PropTypes.instanceOf(OrderFare).isRequired,
        className: PropTypes.string,
        isAmended: PropTypes.bool,
        promoCode: PropTypes.string
    };

    static defaultProps = {
        className: 'margin-bottom padding-bottom border-thick--bottom',
        isAmended: false
    };

    _renderPassengerList () {
        return (
            <ul className="fare__passengers">
                { getFoldedTickets(this.props.orderFare.tickets, (ticket) => ticket.toComparable()).map(
                    (ticket, index) => <TicketDetails key={ index } ticket={ ticket } fare={ this.props.orderFare } isCarnet={ this.props.orderFare.isCarnet() } />) }
            </ul>
        );
    }

    _renderPromoCode(promoCode) {
        const tickets = this.props.orderFare.tickets;

        const hasPromoDiscount = tickets.some(ticket => ticket.hasPromoDiscount());

        if (!hasPromoDiscount) {
            return null;
        }

        return (<div className='applied-code'>
            { t('booking.promoCode.applied', {
                promoCode: promoCode
            }) }
        </div>);
    }

    render () {
        const { orderFare, className, isAmended, promoCode } = this.props;
        const hasRailcards = orderFare.getRailcards().some((railcard) => !railcard.isGroupSave());
        const showRailcardsMessage = hasRailcards && !isAmended;

        return (
            <div className={ 'fare-passengers ' + className }>
                { this._renderPassengerList() }
                <FareRefundsInfo fare={orderFare} small />
                { this._renderPromoCode(promoCode) }
                { showRailcardsMessage && <p className='text-secondary no-margin text-sm'> { t('order.summary.bring_railcard') }</p> }
            </div>
        );
    }

}


export default FarePassengers;
